// The four authored landmarks, as data. Until now their coordinates lived
// only in the client's POI renderer, which was fine while they were pure
// set dressing; the moment anything server-side needs to know where they
// are (the derelict seeder scatters equipment around them), the positions
// have to be shared or they fork. Names are working placeholders pending
// founder naming (docs/design/trades.md, founder question five).

export interface Landmark {
  readonly id: string;
  /** Player-facing label (placeholder until founders name the places). */
  readonly label: string;
  readonly x: number;
  readonly z: number;
}

/** North is −z; placements from docs/design/planet-and-resources.md. */
export const LANDMARKS: readonly Landmark[] = [
  { id: "wreck", label: "the Wreck", x: 3535, z: -3535 },
  { id: "geyser-field", label: "the Geyser Field", x: -2121, z: 2121 },
  { id: "obelisk", label: "the Obelisk", x: 7000, z: 0 },
  { id: "mesa-gate", label: "the Mesa Gate", x: 0, z: -6000 },
  // Wave-9 round 4 moved the barge ~180 m from the frozen-flats camera
  // for hero pixel weight (r4t0 at 220 m sat half-hidden behind a crest).
  { id: "derelict-barge", label: "the Derelict Barge", x: 3640, z: -4360 },
] as const;

const byId = new Map(LANDMARKS.map((l) => [l.id, l]));

/** Own-property lookup (a Map cannot be prototype-polluted by an id). */
export function landmarkById(id: string): Landmark | undefined {
  return byId.get(id);
}
